var meta = { showLeftMenu: false, headIndex: 2 };
export var router = [
	{
		path: '/chatbotStatistics',
		meta: meta,
		name: 'chatbotStatistics',
		component: resolve => require(["./statistics.vue"], resolve)
	}]



// WEBPACK FOOTER //
// ./src/views/chatbot/router.js